import { getDbamBase } from '../contexts/AuthContext';
import { SIGNED_OUT_PREVIEW, WORKING_ORG_ID } from '../config';
import { getSessionToken } from './session';

async function request(path, options = {}) {
    const bearer = getSessionToken();
    if (SIGNED_OUT_PREVIEW && !bearer) {
        const error = new Error('Sign in to manage channel accounts.');
        error.code = 'NOT_SIGNED_IN';
        throw error;
    }
    const headers = { ...(options.headers || {}) };
    if (bearer) headers.Authorization = `Bearer ${bearer}`;
    if (WORKING_ORG_ID) headers['X-Org-ID'] = WORKING_ORG_ID;
    let body = options.body;
    if (body !== undefined) {
        headers['Content-Type'] = 'application/json';
        body = JSON.stringify(body);
    }
    const response = await fetch(`${getDbamBase()}${path}`, { ...options, headers, body, credentials: 'include' });
    const data = response.status === 204 ? null : await response.json().catch(() => null);
    if (!response.ok) {
        const apiError = data?.error;
        const error = new Error(data?.message || apiError?.message || (typeof apiError === 'string' ? apiError : '') || `Request failed (${response.status})`);
        error.status = response.status;
        error.code = data?.code || apiError?.code;
        throw error;
    }
    // DBAM's shared contract is {data,meta}; retain compatibility with the few
    // bare legacy responses but never hand envelope metadata to a panel as if
    // it were channel state.
    if (data && Object.prototype.hasOwnProperty.call(data, 'data') && Object.prototype.hasOwnProperty.call(data, 'meta')) {
        return data.data;
    }
    return data;
}

export const getManagedChannel = (channel) => request(`/dbam/v1/channels/management/${encodeURIComponent(channel)}`);
export const saveAccountDraft = (channel, config, secretValues = {}) => request(`/dbam/v1/channels/management/${encodeURIComponent(channel)}/account-draft`, { method: 'PUT', body: { config, secret_values: secretValues } });
export const saveBindingDraft = (bindingId, config, secretValues = {}) => request(`/dbam/v1/channels/bindings/${encodeURIComponent(bindingId)}/management-draft`, { method: 'PUT', body: { config, secret_values: secretValues } });
export const testBindingDraft = (bindingId) => request(`/dbam/v1/channels/bindings/${encodeURIComponent(bindingId)}/management-test`, { method: 'POST' });
export const promoteBindingDraft = (bindingId) => request(`/dbam/v1/channels/bindings/${encodeURIComponent(bindingId)}/management-save`, { method: 'POST' });
export const saveInstructionProgress = (bindingId, progress) => request(`/dbam/v1/channels/bindings/${encodeURIComponent(bindingId)}/instruction-progress`, { method: 'PUT', body: { progress } });
export const sendInstructions = (bindingId) => request(`/dbam/v1/channels/bindings/${encodeURIComponent(bindingId)}/instructions`, { method: 'POST' });
export const getInstructionDelivery = (bindingId, deliveryId) => request(`/dbam/v1/channels/bindings/${encodeURIComponent(bindingId)}/instructions/${encodeURIComponent(deliveryId)}`);
export const transitionManagedBinding = (bindingId, state, reason) => request(`/dbam/v1/channels/bindings/${encodeURIComponent(bindingId)}/transition`, { method: 'POST', body: { state, reason } });
export const stopManagedBinding = (bindingId) => request(`/dbam/v1/channels/bindings/${encodeURIComponent(bindingId)}/stop`, { method: 'POST' });
export const createManagedBinding = (channel, displayLabel, provider) => request('/dbam/v1/channels/bindings', { method: 'POST', body: { channel, ownership_mode: channel === 'sms' || channel === 'rcs' ? 'hosted' : 'customer_owned', provider, display_label: displayLabel, platform_identifiers: {} } });
